import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const PerfilService = {
    fetchPerfiles: async (token) => {
        try {
            const response = await axios.get(buildApiUrl('/api/ajustes/perfiles'), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.perfiles || [];
        } catch (error) {
            console.error('Error en PerfilService.fetchPerfiles:', error);
            throw error;
        }
    },
    guardarPerfil: async ({ token, formData, editingItem }) => {
        try {
            if (editingItem) {
                await axios.put(
                    buildApiUrl(`/api/ajustes/perfiles/${editingItem.id}`),
                    formData,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
            } else {
                await axios.post(buildApiUrl('/api/ajustes/perfiles'), formData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
        } catch (error) {
            console.error('Error en PerfilService.guardarPerfil:', error);
            throw error;
        }
    },
    getPermisos: async (token) => {
        try {
            const response = await axios.get(buildApiUrl('/api/ajustes/permisos'), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.permisos || [];
        } catch (error) {
            console.error('Error en PerfilService.fetchPerfiles:', error);
            throw error;
        }
    },
    getPermisosByPerfil: async (token, perfilId) => {
        try {
            const response = await axios.get(buildApiUrl(`/api/ajustes/perfiles/${perfilId}/permisos`), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.permisosPerfil || [];
        } catch (error) {
            console.error('Error en PerfilService.fetchPerfiles:', error);
            throw error;
        }
    },
    guardarPermisos: async (token, formData, perfilId) => {
        try {
            await axios.put(
                buildApiUrl(`/api/ajustes/perfiles/${perfilId}/permisos`),
                formData,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
        } catch (error) {
            console.error('Error en PerfilService.guardarPerfil:', error);
            throw error;
        }
    },
};
